import { render, staticRenderFns } from "./verifikasiWajah.vue?vue&type=template&id=38140efe&"
import script from "./verifikasiWajah.vue?vue&type=script&lang=js&"
export * from "./verifikasiWajah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QSelect,QItem,QItemSection,QBadge,QBtnGroup,QDialog,QCardActions,QChatMessage,QIcon,QImg,QSpinnerIos,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QSelect,QItem,QItemSection,QBadge,QBtnGroup,QDialog,QCardActions,QChatMessage,QIcon,QImg,QSpinnerIos})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
